module.exports = __webpack_public_path__ + "img/72_12.44918dfa.png";